// Moteur de traduction FR → ES à la volée (MutationObserver).
// Ne modifie aucun composant existant : les nœuds texte + attributs sont traduits
// via le dictionnaire i18n/es.js quand la langue de l'utilisateur est "es".
import { DICT, PATTERNS } from "./es";
import { AUTO_DICT } from "./es-auto";

const FULL_DICT = { ...AUTO_DICT, ...DICT };

let observer = null;
let currentLang = "fr";
const ATTRS = ["placeholder", "title", "aria-label"];
const SKIP_TAGS = new Set(["SCRIPT", "STYLE", "NOSCRIPT"]);

function translate(s) {
  if (!s) return s;
  const t = s.trim();
  if (!t) return s;
  let hit = FULL_DICT[t];
  if (!hit && /\s\s|\n/.test(t)) {
    hit = FULL_DICT[t.replace(/\s+/g, " ")];
  }
  if (hit) return s.replace(t, hit);
  for (const p of PATTERNS) {
    const m = t.match(p.re);
    if (m) return s.replace(t, p.out(m));
  }
  return s;
}

function translateAttrs(el) {
  if (!el.getAttribute) return;
  for (const a of ATTRS) {
    const v = el.getAttribute(a);
    if (v) {
      const nv = translate(v);
      if (nv !== v) el.setAttribute(a, nv);
    }
  }
}

function walk(root) {
  if (!root) return;
  if (root.nodeType === Node.TEXT_NODE) {
    const nv = translate(root.nodeValue);
    if (nv !== root.nodeValue) root.nodeValue = nv;
    return;
  }
  if (root.nodeType !== Node.ELEMENT_NODE || SKIP_TAGS.has(root.tagName)) return;
  translateAttrs(root);
  if (root.querySelectorAll) {
    root.querySelectorAll("[placeholder],[title],[aria-label]").forEach(translateAttrs);
  }
  const tw = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
  let n;
  while ((n = tw.nextNode())) {
    if (n.parentElement && SKIP_TAGS.has(n.parentElement.tagName)) continue;
    const nv = translate(n.nodeValue);
    if (nv !== n.nodeValue) n.nodeValue = nv;
  }
}

function start() {
  walk(document.body);
  if (observer) return;
  observer = new MutationObserver((muts) => {
    for (const m of muts) {
      if (m.type === "characterData") {
        const nv = translate(m.target.nodeValue);
        if (nv !== m.target.nodeValue) m.target.nodeValue = nv;
      } else if (m.type === "childList") {
        m.addedNodes.forEach((n) => walk(n));
      } else if (m.type === "attributes") {
        translateAttrs(m.target);
      }
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ATTRS,
  });
}

function stop() {
  if (observer) {
    observer.disconnect();
    observer = null;
    // Recharge pour restaurer les libellés français d'origine
    window.location.reload();
  }
}

export function getStoredLanguage() {
  return localStorage.getItem("fc_lang") === "es" ? "es" : "fr";
}

export function applyUserLanguage(lang) {
  const l = lang === "es" ? "es" : "fr";
  localStorage.setItem("fc_lang", l);
  if (l === "es") {
    currentLang = "es";
    if (document.body) start();
    else window.addEventListener("DOMContentLoaded", start, { once: true });
  } else if (currentLang === "es") {
    currentLang = "fr";
    stop();
  }
}
